// Generated from products/analytics/shared/custom/aliveByMistake/context.ts; run analytics generate:site-runtime.
import { z } from "zod";

/** Alive by Mistake identifiers are bounded catalog keys, never arbitrary diagnostics. */
export const AliveByMistakeKeySchema = z.string().min(1).max(100);
export const AliveByMistakeCountSchema = z
  .number()
  .int()
  .nonnegative()
  .max(Number.MAX_SAFE_INTEGER);

export const AliveByMistakeContextSchema = z.strictObject({
  runId: z.uuid(),
  attemptId: z.uuid(),
  release: AliveByMistakeKeySchema,
  map: z.number().int().min(0).max(100),
  wave: z.number().int().min(1).max(250),
  difficulty: z.number().int().min(0).max(2),
  input: z.enum(["touch", "keyboardMouse", "gamepad", "unknown"]),
  playerLevel: z.number().int().positive().max(Number.MAX_SAFE_INTEGER),
  perks: z.array(AliveByMistakeKeySchema).max(16),
  qa: z.boolean(),
});
export const AliveByMistakeAccountContextSchema = AliveByMistakeContextSchema.extend({
  runId: z.null(),
  attemptId: z.null(),
  map: z.null(),
  wave: z.null(),
  difficulty: z.null(),
});
export const AliveByMistakeChoiceContextSchema = z.union([
  AliveByMistakeContextSchema,
  AliveByMistakeAccountContextSchema,
]);
export type AliveByMistakeContext = z.infer<typeof AliveByMistakeContextSchema>;
export type AliveByMistakeAccountContext = z.infer<typeof AliveByMistakeAccountContextSchema>;
export type AliveByMistakeChoiceContext = z.infer<typeof AliveByMistakeChoiceContextSchema>;
